module.exports = __webpack_public_path__ + "img/spaced-repetition.70dcfce9.svg";